import { get } from '../index'


export const getVideoCount = get('/statistic/video/count')
export const getTemplateCount = get('/statistic/template/count')
